module.exports = __webpack_public_path__ + "img/logo-training.208b64d7.svg";